import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";
import type { UserData } from "@/service/auth-service";

export type UserRole = "trainer" | "client";

interface UserStore {
  role: UserRole;
  setRole: (role: UserRole) => void;
  clearRole: () => void;
  user: UserData | null;
  setUser: (user: UserData | null) => void;
  isAuthenticated: boolean;
  setIsAuthenticated: (isAuthenticated: boolean) => void;
  clearAuth: () => void;
}

export const useUserStore = create<UserStore>()(
  persist(
    (set, get) => ({
      role: "trainer" as UserRole,
      user: null,
      isAuthenticated: false,
      setRole: (role: UserRole) => {
        set({ role });
      },
      clearRole: () => set({ role: "trainer" }),
      setUser: (user: UserData | null) => {
        set({ user, isAuthenticated: !!user });
      },
      setIsAuthenticated: (isAuthenticated: boolean) => {
        set({ isAuthenticated });
      },
      clearAuth: () => {
        set({ user: null, isAuthenticated: false });
      },
    }),
    {
      name: "user-storage", // unique name for localStorage key
      storage:
        typeof window !== "undefined"
          ? createJSONStorage(() => localStorage)
          : undefined, // use localStorage in browser
      onRehydrateStorage: () => (state) => {
        // This runs after hydration from localStorage
        if (state && state.role) {
        }
      },
    }
  )
);
